@if (show) {
  <div class="pwa-ios-sheet" role="dialog" aria-label="Installer albR sur iOS">
    <button class="close" type="button" aria-label="Fermer" (click)="dismiss()">
      &times;
    </button>
    <div class="head">
      <span class="ic"><img src="assets/icons/albr-mark.svg" alt="" /></span>
      <b>Installer albR sur votre iPhone</b>
    </div>
    <ol>
      <li>
        <span class="step">1</span>
        <span>Touchez</span>
        <span class="share" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 3v12M12 3l-4 4M12 3l4 4M5 12v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7"
            />
          </svg>
        </span>
        <b>Partager</b>
      </li>
      <li><span class="step">2</span> Choisissez « Sur l'écran d'accueil »</li>
      <li><span class="step">3</span> Confirmez « Ajouter »</li>
    </ol>
  </div>
}
